import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { VStack } from "@whoosh/design-system/src/components/primitive";
import { PackageBenefitsSummary } from "@whoosh/features/src/Packages";

import { PackageType } from "../../CurrentPackagesModal/components/__generated__/ModalLoaderQuery.graphql";
import { PackageDetailActions } from "./PackageDetailActions";
import { PackageDetailBilling } from "./PackageDetailBilling";
import { PackageDetail_memberPackage$key } from "./__generated__/PackageDetail_memberPackage.graphql";

type Props = {
  type: PackageType;
  memberPackageRef?: PackageDetail_memberPackage$key | null;
};
export const PackageDetail = ({ type, memberPackageRef }: Props) => {
  const memberPackage = useFragment(
    PackageDetailFragmentString,
    memberPackageRef
  );

  return (
    <VStack px={6} gap={2} pb={10}>
      <PackageDetailBilling memberPackageRef={memberPackage} />
      <PackageDetailActions packageRef={memberPackage} type={type} />
      <PackageBenefitsSummary packageRef={memberPackage?.package} />
    </VStack>
  );
};

const PackageDetailFragmentString = graphql`
  fragment PackageDetail_memberPackage on MemberPackage {
    id
    ...PackageDetailActions_memberPackage
    ...PackageDetailBilling_memberPackage
    package {
      ...PackageBenefitsSummary_package
    }
  }
`;
